import Axios from 'axios';
import moment from 'moment';
import { LOGIN_ENDPOINTS, STORAGE } from './constants/GlobalConstants';
import { redirectLogout, renewToken } from './utils/RoutingUtils';

const tokenBlackList = [...Object.values(LOGIN_ENDPOINTS)];

const needsToken = request => {
  return tokenBlackList.every(path => !request.url.includes(path));
};

const getToken = () => {
  if (STORAGE.get(STORAGE.TOKEN)) {
    const token = STORAGE.get(STORAGE.TOKEN);

    const expiration = moment(token.expiration);
    const expMinusMinute = moment(token.expiration).subtract(1, 'minutes');
    const now = moment();

    if (now.isBetween(expMinusMinute, expiration)) {
      return renewToken();
    } else if (now.isBefore(expMinusMinute)) {
      return token.token;
    } else {
      STORAGE.clear();
      redirectLogout();
    }
  }
};

const instance = Axios.create({
  baseURL: `${process.env.NODE_ENV == 'development' ? process.env.REACT_APP_BASE_URL : window.location.origin}${
    process.env.REACT_APP_SUBDOMAIN
  }/api`,
});

instance.interceptors.request.use(
  request => {
    if (needsToken(request)) {
      request.headers['Authorization'] = `Bearer ${getToken(request)}`;
    }

    return request;
  },
  error => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    throw error;
  }
);

export default instance;
